export enum FacilityOperatingHoursInputNames {
  OPERATING_HOURS = "facilityOperatingHours",
  OPERATING_HOURS_START = "operatingHoursStart",
  OPERATING_HOURS_END = "operatingHoursEnd",
}
